"use client";

import { useState } from "react";
import { useMutation } from "convex/react";
import { api } from "@repo/backend/convex/_generated/api";

export function MentorsComingSoon() {
  const addToNotifyList = useMutation(api.siteSettings.addToNotifyList);
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (submitting) return;
    setError(null);
    setSubmitting(true);
    try {
      await addToNotifyList({ email, feature: "mentors" });
      setDone(true);
      setEmail("");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col items-center text-center py-16">
      <span className="rounded-full border border-[var(--border)] bg-[var(--card)] px-3 py-1 text-xs uppercase tracking-wide text-[var(--muted-foreground)]">
        Coming Soon
      </span>
      <h1 className="mt-6 text-4xl md:text-5xl font-script text-[var(--foreground)]">
        Mentors — Coming Soon
      </h1>
      <p className="mt-4 max-w-xl text-lg text-[var(--muted-foreground)] font-polysans">
        We&apos;re building a directory of students from UCL, Oxbridge, and Imperial to offer 1-1
        support. Get notified when we launch.
      </p>

      {done ? (
        <p className="mt-8 font-polysans text-[var(--foreground)]">
          Thanks! We&apos;ll email you when mentors go live. 🎉
        </p>
      ) : (
        <form onSubmit={submit} className="mt-8 flex w-full max-w-md flex-col sm:flex-row gap-3">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            className="flex-1 rounded-full border border-[var(--border)] bg-[var(--background)] px-4 py-2.5 text-[var(--foreground)] placeholder:text-[var(--muted-foreground)] focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
          />
          <button
            type="submit"
            disabled={submitting}
            className="rounded-full bg-[var(--primary)] px-6 py-2.5 text-white shadow-sm hover:shadow-md transition-all disabled:opacity-60"
          >
            {submitting ? "…" : "Notify me"}
          </button>
        </form>
      )}
      {error && <p className="mt-3 text-sm text-red-500">{error}</p>}
    </div>
  );
}
